import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const FontStyling = css`
  color: ${({ theme }) => theme.color.spaceGray};
  h2,
  h3 {
    margin-block-start: 2em;
  }
  ul > li {
    position: relative;
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
    margin-left: ${({ theme }) => theme.x2spacePx}px;
    &:before {
      position: absolute;
      content: '•';
      color: black;
      left: -${({ theme }) => theme.x2spacePx}px;
    }
  }
  ol {
    counter-reset: list;
  }
  ol > li {
    position: relative;
    list-style: none;
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
    margin-left: ${({ theme }) => theme.x4spacePx}px;
    &:before {
      position: absolute;
      left: -${({ theme }) => theme.x4spacePx}px;
      top: 0.3rem;
      content: '(' counter(list, lower-roman) ')';
      counter-increment: list;
    }
  }
`;

export const Header = styled('header')`
  color: ${({ theme }) => theme.color.spaceGray};
  padding-top: 24px;
  padding-left: 16px;
  ${media.mdDown`
    padding-top: 16px;
    padding-bottom: 16px;
  `}
  h1 {
    ${({ theme }) => theme.typography.mega}
    letter-spacing: -0.02em;
    font-weight: 700;
    line-height: 36px;
    margin: auto;
    ${media.lgUp`
      font-size: 3.2rem;
    `}
  }
  p {
    font-style: italic;
    margin: ${({ theme }) => `${theme.x1spacePx}px 0px 0px`};
  }
`;

export const InnerContainer = styled('section')`
  position: relative;
  max-width: ${({ theme }) => theme.xlMin};
  width: 100%;
  padding: ${({ theme }) => `0px ${theme.x2spacePx}px ${theme.x2spacePx}px`};

  ${media.lgUp`
    padding: ${({ theme }) => `0px ${theme.x5spacePx}px ${theme.x5spacePx}px`};
	`};

  ${FontStyling}
`;
